export enum AuthStatus {
  INITIALIZING = "INITIALIZING",
  SIGNED_OUT = "SIGNED_OUT",
  SIGNING_IN = "SIGNING_IN",
  REQUESTING_DRIVE_ACCESS = "REQUESTING_DRIVE_ACCESS",
  DRIVE_ACCESS_REQUIRED = "DRIVE_ACCESS_REQUIRED",
  AUTHORIZED = "AUTHORIZED",
}

export default interface AuthContextValue {
  status: AuthStatus;
  isLoading: boolean;
  isAuthorized: boolean;
  googleAccessToken?: string;
  needsDriveAccess: boolean;
  renderSignInButton: (parent: HTMLElement) => void;
  requestDriveAccess: () => void;
  signOut: () => void;
}
